// extracted by mini-css-extract-plugin
export default {"wrapper":"-oBoPs9IqvTkE7-PmRGq5w==","illustration":"wUxA6-IovM0r0Jt10n0qlw==","controls":"aueRKhlWXUD+4DYcZrFsgQ=="};